import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export default function useScrollOrNavigate() {
    const navigate = useNavigate();

    const scrollOrNavigate = useCallback((e, targetId = 'contact-form', fallbackPath = '/contact') => {
        if (e) e.preventDefault();

        // Try to find the element by the supplied ID
        const targetEl = document.getElementById(targetId);

        if (targetEl) {
            targetEl.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        // If not found -> navigate
        navigate(fallbackPath);
    },
        [navigate]
    );

    return scrollOrNavigate;
}